<template>
<div class="chapter">
<div class="inner_page">
<p class="dedication"><a id="page_vii"></a><em>for our families,<br/>wherever we may find them</em></p>
<p class="imagec"><img alt="image" src="images/common1.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?1420da06